/*
 * @format
 */

import React from 'react';

import Steps from './Steps';
import { CHOOSE_MODE, OPEN_MODE_PICKER } from './copy';
import WatchModeTapDiagram from './WatchModeTapDiagram';
import WatchModeListDiagram from './WatchModeListDiagram';
import WatchPlusHoursDiagram from './WatchPlusHoursDiagram';

/*
 * Setting Plus Hours takes three screens on the watch — open the mode picker,
 * choose Plus Hours, set the duration — so the topic is told as three steps
 * rather than one long page.
 */
const steps = [
  {
    body: `${OPEN_MODE_PICKER} ${CHOOSE_MODE}`,
    diagram: <WatchModeTapDiagram />,
  },
  {
    body:
      'You can extend the time of your current temperature by enabling Plus ' +
      'Hours.',
    diagram: <WatchModeListDiagram target="Plus Hours" />,
  },
  {
    body: 'Set how long you wish to extend your current temperature.',
    diagram: <WatchPlusHoursDiagram />,
  },
];

function WatchAppHelpPlusHoursScreen({ navigation }) {
  return (
    <Steps title="Setting Plus Hours" steps={steps} navigation={navigation} />
  );
}

export default WatchAppHelpPlusHoursScreen;
